import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle1 } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalTermsOfUseHR extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Uvjeti korištenja za web stranicu Glossiq';
		const siteDescription =
			"Dobrodošli na web stranicu Glossiq (u daljnjem tekstu 'web stranica' ili 'sajt'). Molimo vas da pažljivo pročitate ove Uvjete korištenja prije nego što pristupite web stranici ili koristite bilo koji od njezinih sadržaja ili usluga (u daljnjem tekstu 'Usluge'). Korištenjem ove web stranice ili njezinih usluga pristajete na sve uvjete i odredbe navedene u ovom Ugovoru.";
		const siteKeywords = 'Terms of use default keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/termsofuse/hr';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<img src={require('../../../containers/Html/icons/symbol1.svg')} alt="glossiq icon" />
						<InfoPageHeaderTitle>Uvjeti korištenja za web stranicu Glossiq</InfoPageHeaderTitle>
						<p></p>
						<p>
							Dobrodošli na web stranicu Glossiq (u daljnjem tekstu "web stranica" ili "sajt"). Molimo vas da pažljivo
							pročitate ove Uvjete korištenja prije nego što pristupite web stranici ili koristite bilo koji od njezinih
							sadržaja ili usluga (u daljnjem tekstu "Usluge"). Korištenjem ove web stranice ili njezinih usluga
							pristajete na sve uvjete i odredbe navedene u ovom Ugovoru.
						</p>
					</InfoPageHeaderSection>
					<hr />
					<InfoPageSection>
						<InfoPageTitle1>Prihvaćanje uvjeta </InfoPageTitle1>
						<p>
							Korištenjem web stranice, prihvaćate i slažete se s ovim Ugovorom. Ako se ne slažete s bilo kojim dijelom
							ovih uvjeta, molimo vas da ne koristite web stranicu ili bilo koje njene usluge.
						</p>
						<InfoPageTitle1>Promjene uvjeta </InfoPageTitle1>
						<p>
							Glossiq zadržava pravo izmjene ovih Uvjeta i to u bilo kojem trenutku. Takve promjene će stupiti na snagu
							objavljivanjem na ovoj stranici i/ili ažuriranjem datuma izmjene Uvjeta i uvjeta u nastavku.
						</p>
						<InfoPageTitle1>Promjene na web stranici</InfoPageTitle1>
						<p>
							Glossiq zadržava pravo izmjene, privremenog ili trajnog prekida web stranice ili bilo koje usluge povezane
							s njom, s ili bez prethodne najave, i bez ikakve odgovornosti prema vama.
						</p>
						<InfoPageTitle1>Ažuriranja web stranice </InfoPageTitle1>
						<p>
							Glossiq može povremeno pružiti poboljšanja ili nadogradnje funkcija/funkcionalnosti web stranice,
							uključujući zakrpe, ispravke grešaka, nadogradnje, unapređenja i druge promjene ("Ažuriranja").
						</p>
						<p>
							Ažuriranja mogu promijeniti ili ukloniti određene funkcije i/ili funkcionalnosti web stranice. Slažete se
							da će Ažuriranja biti (i) sastavni dio web stranice i (ii) podložna uvjetima i odredbama ovog Ugovora.
						</p>
						<InfoPageTitle1>Usluge trećih strana </InfoPageTitle1>
						<p>
							Možemo prikazivati, uključivati ili omogućiti sadržaje trećih strana (uključujući podatke, informacije,
							aplikacije i druge proizvode ili usluge) ili pružiti veze prema web stranicama ili uslugama trećih strana
							("Usluge trećih strana"). Priznajete i slažete se da Glossiq neće biti odgovoran za bilo koje Usluge
							trećih strana, uključujući njihovu točnost, potpunost, pravovremenost, valjanost, sukladnost s autorskim
							pravima, zakonitošću, pristojnošću, kvalitetom ili bilo kojim drugim aspektom. Glossiq ne preuzima i neće
							imati nikakvu odgovornost prema vama ili bilo kojoj drugoj osobi ili entitetu za bilo koje Usluge trećih
							strana.
						</p>
						<InfoPageTitle1>Raskid ugovora</InfoPageTitle1>
						<p>Ovaj Ugovor ostaje na snazi sve dok ga vi ili Glossiq ne raskinete.</p>
						<p>
							Glossiq može, prema vlastitom nahođenju, u bilo kojem trenutku i iz bilo kojeg razloga ili bez razloga
							suspendirati ili raskinuti ovaj Ugovor, s ili bez prethodne najave.
						</p>
						<p>
							Ovaj Ugovor će se odmah prekinuti, bez prethodne najave od strane Glossiq-a, u slučaju da ne ispunjavate
							bilo koju odredbu ovog Ugovora. Također možete prekinuti ovaj Ugovor brisanjem web stranice i svih njenih
							kopija s vašeg računala.
						</p>
						<InfoPageTitle1>Obavijest o povredi autorskih prava</InfoPageTitle1>
						<p>
							Ako ste vlasnik autorskih prava ili agent takvog vlasnika i smatrate da bilo koji materijal na našoj web
							stranici predstavlja povredu vaših autorskih prava, obratite nam se pružanjem sljedećih informacija: (a)
							fizički ili elektronički potpis vlasnika autorskih prava ili osobe ovlaštene da djeluje u njegovo ime; (b)
							identifikacija materijala za koji smatrate da predstavlja povredu; (c) vaši kontakt podaci, uključujući
							adresu, telefonski broj i e-mail adresu; (d) izjava od strane vas da imate razloga vjerovati da se
							materijal ne koristi s dozvolom vlasnika autorskih prava; i (e) izjava da su informacije u obavijesti
							točne i da, pod prijetnjom krivičnog progona, imate ovlaštenje djelovati u ime vlasnika.
						</p>
						<InfoPageTitle1>Nadoknada štete</InfoPageTitle1>
						<p>
							Slažete se da ćete nadoknaditi i zaštititi Glossiq i njene matične tvrtke, podružnice, partnere,
							službenike, zaposlenike, agente, partnere i davalice licenci (ako postoje) od svakog zahtjeva ili
							zahtjeva, uključujući razumne pravne troškove, koji proizlaze ili su povezani s: (a) korištenjem web
							stranice; (b) kršenjem ovog Ugovora ili bilo kojeg zakona ili propisa; ili (c) kršenjem prava trećih
							strana.
						</p>
						<InfoPageTitle1>Nema garancije</InfoPageTitle1>
						<p>
							Web stranica vam se pruža "KAKVA JEST" i "KAKO JE DOSTUPNA" i sa svim nedostacima i greškama. Glossiq ne
							daje nikakve izjave ili garancije bilo koje vrste, izričite ili implicirane: (a) u vezi s točnošću,
							prikladnošću, pravovremenosti ili potpunosti web stranice ili informacija sadržanih ili dobivenih putem
							web stranice; (b) da će korištenje web stranice biti sigurno, neprekidno ili bez grešaka; (c) u vezi s
							kvalitetom web stranice ili bilo kojeg sadržaja dobivenog putem web stranice; ili (d) da će se pogreške na
							web stranici ispraviti.
						</p>
						<p>
							Ne preuzimamo nikakvu odgovornost i ne možemo garantirati da je web stranica slobodna od virusa ili drugih
							štetnih materijala. Svi sadržaji preuzeti ili drugačije dobiveni korištenjem web stranice preuzimaju se na
							vaš rizik, a vi ste jedini odgovorni za bilo kakvu štetu vašem računalnom sustavu ili gubitak podataka
							koji proizlazi iz preuzimanja takvih sadržaja. Prikazivanje informacija ili preuzimanje bilo kojeg
							materijala putem korištenja web stranice izvodite prema vašem nahođenju i na vlastiti rizik, te ćete sami
							biti odgovorni za bilo kakvu štetu vašem računalnom sustavu ili gubitak podataka koji proizlazi iz
							preuzimanja takvih materijala. Neki savezi ili pravne jurisdikcije ne dopuštaju isključenje implicitnih
							jamstava ili ograničenje ili isključenje odgovornosti za slučajne ili posljedične štete, pa stoga navedena
							ograničenja ili isključenja možda neće vrijediti za vas. U tim savezima ili pravnim jurisdikcijama,
							odgovornost Glossiq-a bit će ograničena maksimalno dopuštenim zakonom.
						</p>
						<InfoPageTitle1>Ograničenje odgovornosti </InfoPageTitle1>
						<p>
							U nikakvom slučaju Glossiq ili njeni davatelji usluga neće biti odgovorni prema vama ili bilo kojoj drugoj
							osobi ili entitetu za izravnu, neizravnu, posebnu, slučajnu, posljedičnu ili kaznenu štetu bilo koje
							vrste, uključujući, ali ne ograničavajući se na, gubitak profita, gubitak mogućnosti, gubitak podataka,
							troškove pokrića ili bilo koju drugu vrstu gubitka ili štete bilo koje vrste, čak i ako su obaviješteni o
							mogućnosti takve štete, bilo ugovorne, neoprostive (uključujući nemar), strogog odgovora ili drugačije
							proizišle ili povezane s korištenjem ili nesposobnošću korištenja web stranice ili bilo koje usluge ili
							sadržaja (uključujući materijale) prisutnih na web stranici ili dobivenih putem web stranice. U nikakvom
							slučaju ukupna odgovornost Glossiq-a za sve zahtjeve proizišle iz ili u vezi s korištenjem web stranice
							ili usluga ili sadržaja prisutnih na web stranici neće premašiti iznos koji ste platili Glossiq-u, ako je
							primjenjivo, za korištenje web stranice tijekom razdoblja od tri (3) mjeseca neposredno prije datuma
							nastanka temelja za zahtjev. Neki savezi ili pravne jurisdikcije ne dopuštaju isključenje ili ograničenje
							odgovornosti za posljedičnu ili slučajnu štetu, pa stoga navedena ograničenja ili isključenja možda neće
							vrijediti za vas. U tim savezima ili pravnim jurisdikcijama, odgovornost Glossiq-a bit će ograničena
							maksimalno dopuštenim zakonom.
						</p>
						<InfoPageTitle1>Priznanje</InfoPageTitle1>
						<p>
							Priznajete da ste pročitali ove Uvjete i odredbe, uključujući Pravilnik o privatnosti, i prihvaćate sve
							njihove uvjete i odredbe. Korištenjem web stranice ili usluga pristajete biti vezani ovim Uvjetima i
							odredbama. Ako ne prihvaćate uvjete ovih Uvjeta i odredbi, niste ovlašteni koristiti web stranicu ili
							usluge.
						</p>
						<InfoPageTitle1>Kontaktirajte nas</InfoPageTitle1>
						<p>Ako imate pitanja o ovim Uvjetima i odredbama, kontaktirajte nas na</p>
						na adresi : <a href="mailto:support@glossiq.com">support@glossiq.com</a>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalTermsOfUseHR };
